import { useEffect, useRef, useState } from "react";
import useExploreInfo from "Hooks/useExploreInfo";
import { useSelector } from "react-redux";
import { getUnitCollaboratorsGraphById } from "Explore/Services/Unit";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { ParamsFilterKey } from "Config/filterSearchParams";
import D3Graph from "Explore/Components/Graph";
import ModeSelect from "Explore/Components/ModeSelect";
import _ from "lodash";
import styles from "./UnitCollaboratorGraph.module.scss";

const UnitCollaboratorGraph = () => {
    const { filter } = useFilterAndPagination({
        [ParamsFilterKey.TOP_K]: 10,
    });
    const { unit_id } = useExploreInfo();
    const { selectedKeywords } = useSelector((state) => state.conceptState) || {};
    const [data, setData] = useState({ data: [], isLoading: false });
    const [mode, setMode] = useState("all");
    const prevFilter = useRef({});

    useEffect(() => {
        const _prevFilter = prevFilter.current;
        const currentFilter = {
            unit_id,
            selectedKeywords,
            mode,
            [ParamsFilterKey.TOP_K]: filter[ParamsFilterKey.TOP_K],
            [ParamsFilterKey.TOP_K_EDGES]: filter[ParamsFilterKey.TOP_K_EDGES],
        };

        if (!_.isEqual(_prevFilter, currentFilter)) {
            setData({ data: [], isLoading: true });
            getUnitCollaboratorsGraphById({
                id: unit_id,
                keyword: selectedKeywords,
                mode,
                [ParamsFilterKey.TOP_K]: filter[ParamsFilterKey.TOP_K],
                [ParamsFilterKey.TOP_K_EDGES]: filter[ParamsFilterKey.TOP_K_EDGES],
            })
                .then((res) => {
                    setData({ data: res.data, isLoading: false });
                })
                .catch(() => {
                    setData({ data: [], isLoading: false });
                });

            prevFilter.current = currentFilter;
        }
    }, [
        unit_id,
        selectedKeywords,
        mode,
        filter[ParamsFilterKey.TOP_K],
        filter[ParamsFilterKey.TOP_K_EDGES],
    ]);

    return (
        <div className={styles["collaborator-graph"]}>
            <div className={styles["collaborator-graph__header"]}>
                <h3 className={styles["collaborator-graph__title"]}>
                    Collaborator Network
                </h3>
                <ModeSelect mode={mode} setMode={setMode} />
            </div>
            <D3Graph
                filter={filter}
                data={data.data}
                isLoading={data.isLoading}
                graphType="unit"
            />
        </div>
    );
};

export default UnitCollaboratorGraph;
